<template>
  <div>
    <kst-output print-mode field="ReturnNumber" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="Date" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="SONumber" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RinvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>